import { gql } from "apollo-boost";

// 1단계. 관리자(Administrator)이고 2차 인증이 걸려 있으면 token 대신 challenge 가 온다.
export const LOG_IN = gql`
  mutation AdminLogIn($userId: String!, $password: String!) {
    AdminLogIn(userId: $userId, password: $password) {
      token
      totpRequired
      totpEnrolled
      challenge
    }
  }
`;

// 2단계. 인증 앱 코드 또는 복구코드로 세션 토큰을 받는다.
export const TOTP_VERIFY = gql`
  mutation AdminTotpVerify($challenge: String!, $code: String!) {
    AdminTotpVerify(challenge: $challenge, code: $code)
  }
`;

// 최초 등록: QR·시크릿·복구코드 발급
export const TOTP_ENROLL_START = gql`
  mutation AdminTotpEnrollStart($challenge: String!) {
    AdminTotpEnrollStart(challenge: $challenge) {
      otpauthUri
      secret
      recoveryCodes
    }
  }
`;

// 최초 등록 확정: 첫 코드가 맞으면 세션 토큰 발급
export const TOTP_ENROLL_CONFIRM = gql`
  mutation AdminTotpEnrollConfirm($challenge: String!, $code: String!) {
    AdminTotpEnrollConfirm(challenge: $challenge, code: $code)
  }
`;

export const LOCAL_LOG_IN = gql`
  mutation logUserIn($token: String!) {
    logUserIn(token: $token) @client
  }
`;

export const ADMIN_AUTH_INFO_QUERY = gql`
  mutation AdminAuthInfo($userId: String!, $password: String!) {
    AdminAuthInfo(userId: $userId, password: $password) {
      avatar
      userId
      name
      role
      addCurrency
    }
  }
`;

// 로그인 직후 토큰으로 계정 권한 조회(선택한 로그인 유형 검증용)
export const ADMIN_INFO_QUERY = gql`
  query AdminInfo {
    AdminInfo {
      role
      isFeeManager
      isDonationManager
      isChargeManager
    }
  }
`;
